module.exports = __webpack_public_path__ + "static/media/27-6.19f265f0.mp3";